export default "__VITE_ASSET__lV_DnLQf__"